//ESIZEJEE-2988 script change because twitter change their way of handling tweets in widget.
function showTweets(handle, id, height) {
	var twitterHome = "https://twitter.com/";
	var twitterUrl = twitterHome + handle;
	var widgetID = "twitter_feed_" + id;
	var tweetHeight = document.getElementById(widgetID);
	
	if (document.getElementById(widgetID) !== null) {
		document.getElementById(widgetID).href = twitterUrl;
		tweetHeight.setAttribute("data-height", height);
	}
}